var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"account-pages mt-5 mb-5"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_c('footer',{staticClass:"footer footer-alt"},[_vm._v("\n    2021 - 2024 H. Ayuntamiento de Escarcega\n    \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }